export default "__VITE_ASSET__CS30fD9B__"